import React, { useEffect, useState } from 'react';
import {
	Pulse,
	DEVICES,
	NavigationHelpers,
	NetworkHelper,
	getCurrentEnv,
	useDeviceType,
	Button,
	fetchPropertyConfig
} from 'common-utilities';
import { EVENT_CATEGORY, SCREEN_NAME } from '../../constants';
import PaytmLogo from '../../assets/paytmSheild.svg';
import CallIcon from '../../assets/callIcon.svg';
import CallIconWhite from '../../assets/callIconWhite.svg';
import './style.scss';
import { PAYTM_CARE_URL } from '../../constants';

const ENV = getCurrentEnv();
const screenName = SCREEN_NAME + '_error';
const params = new URLSearchParams(window.location.search);
const sourceFlow = params.get('source_flow') || '';
function Error(props) {
	const Device = useDeviceType();
	const [forgetPassIvr, setforgetPassIvr] = useState('');
	const setConfigData = async () => {
		setforgetPassIvr(await fetchPropertyConfig('forget_password_ivr_number'));
	};
	useEffect(() => {
		setTimeout(() => {
			Pulse.push({
				event_action: 'password_reset_screen_loaded',
				event_category: EVENT_CATEGORY,
				screenName,
				event_label: 'expired',
				event_label2: sourceFlow
			});
		});
		setConfigData();
	}, []);
	return (
		<React.Fragment>
			<div className="errorPageContainer">
				<div className="header-logo-cont">
					<img className="sheild-img" src={PaytmLogo} alt="paytm-icon" />
				</div>
				<div className="infoContainer">
					<div className="heading">Reset Password</div>
					<div className="sub-heading" style={{ fontSize: '14px', marginTop: '20px' }}>
						Your Reset Password link has expired, Link is valid for only 10 minutes.
					</div>
				</div>
				<Button
					variant="mobile-btn"
					className="footer-btn"
					onClick={() => {
						Pulse.push({
							event_action: 'need_help_clicked',
							event_category: EVENT_CATEGORY,
							screenName
						});
						NavigationHelpers.redirectToPaytm(PAYTM_CARE_URL);
					}}
					oauth-id="need_help_btn"
				>
					<span style={{ cursor: 'pointer' }}>Need Help?</span>
				</Button>
			</div>
		</React.Fragment>
	);
}
export default Error;
